export default {
      id: "date-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "sprite.svg#date",
      toString: function () {
        return this.url;
      }
    }